import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useEffect } from 'react';

import * as S from './styles';

interface OfficialStoreMenuFormProps {
  onSubmit: (value: any) => void;
  updating?: boolean;
  description?: string;
}

const OfficialStoreMenuForm: React.FC<OfficialStoreMenuFormProps> = ({ onSubmit, updating, description }) => {
  const [form] = useForm();

  useEffect(() => {
    if (description) form.setFieldsValue({ description });
  }, [description]);

  return (
    <S.CustomForm form={form} layout="vertical" onFinish={onSubmit}>
      <Form.Item
        name="description"
        label="Nome do Menu"
        rules={[{ required: true, message: 'Informe o nome do menu!' }]}
      >
        <S.CustomInput placeholder="Ex: Camisetas" />
      </Form.Item>

      <Form.Item>
        <S.CustomButton type="primary" htmlType="submit">
          {updating ? 'Atualizar Menu' : 'Adicionar Menu'}
        </S.CustomButton>
      </Form.Item>
    </S.CustomForm>
  );
};

export default OfficialStoreMenuForm;
